<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Visualización de datos</v-toolbar-title>
    <v-spacer></v-spacer>
    <div id="draw-shapes"></div>
  </v-toolbar>
</template>

<script>
  export default {

    computed: {
      serie() {
        return this.$store.state.serie
      },
    },

    created () {

      this.$store.dispatch('loadSerieDetail', {
        id: this.$route.params.id
      })
      console.log('CREATED VIEWER')

      this.initialize()

    },
    /*
    mounted() {
      console.log('MOUNTED VIEWER')
      let twoScript = document.createElement('script')
      twoScript.setAttribute('src', '../two.min.js')
      document.head.appendChild(twoScript)

    },
    */

    methods: {
      initialize() {
        console.log('INITIALIZED VIEWER')
        console.log(this.serie);
        
        /*
        var elem = document.getElementById('draw-shapes');
        var params = { width: window.innerWidth, height: window.innerHeight };
        var two = new Two(params).appendTo(elem);
        
        var centerX = window.innerWidth / 2;
        var centerY = window.innerHeight / 2;

        // two has convenience methods to create shapes.
        var circle = two.makeCircle(centerX, centerY, 300);
        
        circle.stroke = 'orangered'; // Accepts all valid css color
        circle.linewidth = 5;
        circle.noFill();var two = new Two(params).appendTo(elem);
        */
        
        
      },
    }
  }
</script>